"use client";

import React from "react";
import { motion } from "framer-motion";

export interface CtlCtaBlockProps {
    text?: string;
    highlight?: string;
}

const fadeInUp = {
    initial: { opacity: 0, y: 30 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true, margin: "-100px" },
    transition: { duration: 0.8, ease: [0.16, 1, 0.3, 1] as const }
};

export default function CtlCtaBlock({
    text = "WE BUILD SEAMLESS TECHNOLOGICAL SOLUTIONS THAT ARE QUALITY ASSURED & RESULT ORIENTED",
    highlight = "QUALITY ASSURED & RESULT ORIENTED"
}: CtlCtaBlockProps) {
    // Split the text to highlight the matching part
    let firstPart = text;
    let secondPart = "";

    if (highlight && text.includes(highlight)) {
        const parts = text.split(highlight);
        firstPart = parts[0] || "";
        secondPart = parts[1] || "";
    }

    return (
        <section className="py-32 px-6 md:px-12 lg:px-24 bg-[#F8FAF8] text-center relative overflow-hidden text-[#444] font-sans antialiased w-full">
            <div className="absolute inset-0 bg-[radial-gradient(#44aa5203_1px,transparent_1px)] [background-size:32px_32px] pointer-events-none" />
            
            <div className="container mx-auto z-10 max-w-4xl relative">
                <motion.div {...fadeInUp} className="space-y-8">
                    <h2 className="text-4xl md:text-5xl lg:text-6xl font-light text-zinc-450 leading-tight select-none">
                        {firstPart}
                        {highlight && text.includes(highlight) && (
                            <span className="font-medium italic text-[#44AA52]">
                                {highlight}
                            </span>
                        )}
                        {secondPart}
                    </h2>
                </motion.div>
            </div>
        </section>
    );
}
